export default {
  LK: {
    pageTitle: "Жеке кабинет",
    subscription: {
      yourSubs: "Сіздің жазылымыңыз",
      plan_1: "Тегін",
      plan_2: "Кеңейтілген",
      plan_3: "Жеке",
      changePlan: "Тарифті өзгерту",
      activeFor: "Белсенді мерзімі",
      nextPayment: "Келесі төлем",
      accessFor: "Қол жеткізу мерзімі",
    },
    settings: "Баптаулар",
    form: {
      labels: {
        status: "Мәртебе",
        spec_med: "Мамандану",
        position: "Лауазым",
        university: "Университет",
      },
      spec_statValues: {
        doctor: "Дәрігер",
        student: "Студент",
        resident: "Ординатор",
        spec_med: "Медициналық ұйым қызметкері",
      },
      spec_medValues: {
        Obstetrician: "Акушер",
        "Obstetrician-gynecologist": "Акушер-гинеколог",
        Allergist: "Аллерголог",
        Angiosurgeon: "Ангиохирург",
        Andrologist: "Андролог",
        Anesthetist: "Анестезиолог",
        Anesthesiologist: "Анестезиолог-реаниматолог",
        Audiologist: "Аудиолог",
        Bacteriologist: "Бактериолог",
        Venereologist: "Венеролог",
        Vertebrologist: "Вертербролог",
        "Laboratory diagnostics doctor": "Зертханалық диагностика дәрігері",
        "Physiotherapy doctor": "Физиотерапия дәрігері",
        "Magnetic resonance imaging doctor": "МРТ дәрігері",
        GP: "Жалпы практика дәрігері",
        "Sports medicine doctor": "Спорттық медицина дәрігері",
        "Ultrasound diagnostic doctor": "УДЗ дәрігері",
        "Functional diagnostics doctor": "Функционалдық диагностика дәрігері",
        Dermatovenerologist: "Дерматовенеролог",
        Dermatologist: "Дерматолог",
        "Pediatric gastroenterologist": "Балалар гастроэнтерологы",
        "Pediatric gynecologist": "Балалар гинекологы",
        "Pediatric cardiologist": "Балалар кардиологы",
        "Pediatric neurologist": "Балалар невропатологы",
        "Child psychiatrist": "Балалар психиатры",
        "Pediatric dentist": "Балалар тіс дәрігері",
        "Pediatric traumatologist-orthopedist": "Балалар травматолог-ортопеді",
        "Pediatric urologist-andrologist": "Балалар уролог-андрологы",
        "Pediatric surgeon": "Балалар хирургі",
        "Pediatric endocrinologist": "Балалар эндокринологы",
        Nutritionist: "Тамақтану маманы",
        "Other specialty": "Басқа мамандық",
        Immunologist: "Иммунолог",
        "Infectious disease specialist": "Инфекционист",
        Cardiologist: "Кардиолог",
        Kinesiotherapist: "Кинезиотерапевт",
        "Clinical Pharmacologist": "Клиникалық фармаколог",
        Coloproctologist: "Колопроктолог",
        Cosmetologist: "Косметолог",
        "Laboratory assistant": "Зертханашы",
        "Speech therapist": "Логопед",
        "ENT (Otorhinolaryngologist)": "ЛОР (Оториноларинголог)",
        Mammologist: "Маммолог",
        Chiropractor: "Қолмен емдеу терапевті",
        Masseur: "Массажист",
        Nurse: "Мейірбике",
        "Medical brother": "Медбрат",
        "Medical Director": "Медициналық директор",
        Mycologist: "Миколог",
        "Expert in narcology": "Нарколог",
        Neurologist: "Невропатолог",
        Neurophysiologist: "Нейрофизиолог",
        Neurosurgeon: "Нейрохирург",
        Neonatologist: "Неонатолог",
        Nephrologist: "Нефролог",
        "Oculist (Ophthalmologist)": "Окулист (Офтальмолог)",
        Oncologist: "Онколог",
        Orthopedist: "Ортопед",
        Osteopath: "Остеопат",
        Parasitologist: "Паразитолог",
        Periodontist: "Пародонтолог",
        Pathologist: "Патологоанатом",
        Teacher: "Оқытушы",
        Pediatrician: "Педиатр",
        "Plastic surgeon": "Пластикалық хирург",
        Proctologist: "Проктолог",
        "Occupational pathologist": "Кәсіптік патология дәрігері",
        Psychiatrist: "Психиатр",
        "Psychiatrist-narcologist": "Психиатр-нарколог",
        Psychologist: "Психолог",
        Psychotherapist: "Психотерапевт",
        Pulmonologist: "Пульмонолог",
        Radiolog: "Радиолог",
        Rehabilitologist: "Реабилитолог",
        Reanimatologist: "Реаниматолог",
        Rheumatologist: "Ревматолог",
        Radiologist: "Рентгенолог",
        "Reproductologist (IVF)": "Репродуктолог (ЭКО)",
        Reflexologist: "Рефлексотерапевт",
        Sexologist: "Сексолог",
        "Cardiovascular surgeon": "Жүрек-қантамыр хирургі",
        Somnologist: "Сомнолог",
        Dentist: "Тіс дәрігері",
        "Childrens-dentist": "Балалар тіс дәрігері",
        "Dental hygienist": "Тіс гигиенисі",
        "Dentist-implantologist": "Имплантолог тіс дәрігері",
        "Dentist-orthodontist": "Ортодонт тіс дәрігері",
        "Orthopedic dentist": "Ортопед тіс дәрігері",
        "Dentist-therapist": "Терапевт тіс дәрігері",
        "Dental surgeon": "Хирург тіс дәрігері",
        Surdolog: "Сурдолог",
        Therapist: "Терапевт",
        Toxicologist: "Токсиколог",
        Traumatologist: "Травматолог",
        "Traumatologist-orthopedist": "Травматолог-ортопед",
        Transplantologist: "Трансплантолог",
        Transfusiologist: "Трансфузиолог",
        Trichologist: "Трихолог",
        Urologist: "Уролог",
        Pharmacist: "Фармаколог",
        Paramedic: "Фельдшер",
        Physiotherapist: "Физиотерапевт",
        Phlebologist: "Флеболог",
        Phoniatrist: "Фониатр",
        Phthisiatrician: "Фтизиатр",
        Surgeon: "Хирург",
        "Implant surgeon": "Имплантолог хирург",
        "Maxillofacial surgeon": "Жақ-бет хирургі",
        Embryologist: "Эмбриолог",
        Endocrinologist: "Эндокринолог",
        Endoscopist: "Эндоскопист",
        Epidemiologist: "Эпидемиолог",
        Epileptologist: "Эпилептолог",
      },
    },
  },
};
